interface FolderTreeNode {
  children?: readonly string[];
}

/** Returns Fluent's next open-item set with a closed branch and all its descendants removed. */
export const updateOpenFolderItems = (
  fluentOpenItems: Iterable<string | number>,
  branchId: string,
  isOpen: boolean,
  nodes: Readonly<Record<string, FolderTreeNode>>
): Set<string> => {
  const next = new Set(Array.from(fluentOpenItems, String));
  if (isOpen) {
    return next;
  }

  const pending = [branchId];
  while (pending.length > 0) {
    const nodeId = pending.pop();
    if (!nodeId) {
      continue;
    }

    next.delete(nodeId);
    pending.push(...(nodes[nodeId]?.children ?? []));
  }

  return next;
};
